(function() {
  function TruncateString() {
    return function(sentence, length) {
      if (!sentence) { return ''; }
      length = parseInt(length, 10);
      if (!length) { return sentence; }
      if (sentence.length <= length) { return sentence; }
      var truncated = sentence.substr(0, length);
      return truncated + '...';
    };
  }

  angular.module('core')
    .filter('truncateString', [TruncateString]);
})();